import PropTypes from 'prop-types';
import ResultsSection from './ResultsSection';

const DetailsContent = ({ pathwayTemplate }) => {
  return (
    <div className="flex flex-col">
      <ResultsSection pathwayTemplate={pathwayTemplate} />
    </div>
  );
};

DetailsContent.propTypes = {
  pathwayTemplate: PropTypes.object.isRequired,
};

export default DetailsContent;
